module.exports = __webpack_public_path__ + "static/media/home-04-mobile.6b93502f.png";